import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/lib/services/goto'
import { appConfig } from '@/app-config.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    redirect: '/!/Index'
  },
  {
    path: '/!/:site?/:eref',
    name: 'Workspace',
    meta: {
      title: appConfig.title,
      // layout: 'empty',
    },
    props: route => ({ ...route.params }),
    component: () => import('@/views/Blueprint.vue')
  },
]

const scrollBehavior = (to, from, savedPosition) => {
  let scrollTo = 0

  if (to.hash) {
    scrollTo = to.hash
  } else if (savedPosition) {
    scrollTo = savedPosition.y
  }

  return goTo(scrollTo)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
})

// Evitando exceção quando navegando para a rota corrente.
const basePush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return basePush.call(this, location).catch(error => {
    if (error.name != "NavigationDuplicated") {
      throw error;
    }
  })
};

router.afterEach((to /*, from */) => {
  const subtitle = to.params?.eref ? ` - ${to.params?.eref}` : null
  document.title = `${appConfig.title}${subtitle}`
})

export default router
